export default __webpack_public_path__ + "static/media/Colors_00.271b60e1.png";